module.exports = __webpack_public_path__ + "img/yj.b7eb058e.png";